import { lazy, Suspense, useMemo } from 'react'

import { useArcadeModalActionOverride } from '@cash-design-system/react'
import { PaymentDeviceCustomizationBlocker } from '@cash-web/protos/squareup/franklin/blockers/payment_device_customization_blocker.pb'

import { BlockerProps } from '../../BaseBlocker/BaseBlocker'

const CardStudioV2 = lazy(() =>
  import('@cash-web/shared-card-studio-feature-main').then(module => ({ default: module.CardStudioV2 }))
)

interface Props extends BlockerProps {
  blocker: PaymentDeviceCustomizationBlocker
}

const LoadingHeaderOverride = () => {
  // Hide the default modal header until CardStudioV2 loads and installs its custom header.
  useArcadeModalActionOverride(
    useMemo(
      () => ({
        type: 'customHeader' as const,
        CustomHeader: null,
      }),
      []
    )
  )

  return null
}

export const BlockerPaymentDeviceCustomization = ({ blocker }: Props) => {
  return (
    <Suspense fallback={<LoadingHeaderOverride />}>
      <CardStudioV2 blocker={blocker} />
    </Suspense>
  )
}
